import { render, staticRenderFns } from "./Photolab.vue?vue&type=template&id=6e42d8ee"
import script from "./Photolab.vue?vue&type=script&lang=js"
export * from "./Photolab.vue?vue&type=script&lang=js"
import style0 from "./Photolab.vue?vue&type=style&index=0&id=6e42d8ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports